import React from 'react';
import { Page } from '../../components/page/Page';
import { TabProps, useTabs } from '../../hooks/use-tabs';
import { usePaginationData } from '../../hooks/use-pagination-data';
import { API_URL } from '../../api/routes';
import { TabForms } from '../../components/shared/TabForms';
import { UsersTable } from '../../components/users/UsersTable';
import { UserForm } from '../../components/users/UserForm';

const defaultTabs: TabProps[] = [
  {
    key: 'list',
    type: 'list',
    label: 'Список',
    closable: false,
  },
];

export const UsersPage = () => {
  const { state, onTableChange, refresh } = usePaginationData(
    `${API_URL}/user`,
  );

  const { TabList, activeKey, closeTab, openTab } = useTabs({
    defaultTabs,
    defaultActiveKey: 'list',
    createLabel: (item) =>
      item ? `Пользователь "${item.name}"` : 'Новый пользователь',
    url: `${API_URL}/user`,
  });

  return (
    <Page
      title="Пользователи"
      subTitle="Просмотр, добавление и редактирование пользователей системы"
      TabList={TabList}
    >
      <UsersTable
        state={state}
        onTableChange={onTableChange}
        show={'list' === activeKey}
        openTab={openTab}
        refresh={refresh}
      />

      <TabForms
        type={['add', 'edit']}
        excludeKeys={['list']}
        renderItem={(item, { key }) => (
          <UserForm
            refresh={refresh}
            closeTab={closeTab}
            key={key}
            item={item}
            tabKey={key}
            show={key === activeKey}
          />
        )}
      />
    </Page>
  );
};
